import { TERRITORY_NAME_INVALID_CHARS_REGEX } from '../validations/constants';

export const generateSlugFromTerritoryName = (territoryName: string): string =>
  territoryName.replaceAll(TERRITORY_NAME_INVALID_CHARS_REGEX, '-').toLowerCase();
